import * as S from "./commonStyles";
import BookIcon from "assets/book.svg";
import ProductIcon from "assets/product.svg";
import BeneficiaryIcon from "assets/beneficiary.svg";
import { useReport } from "contexts/ReportContext";

export function ClientTab() {
  const { report } = useReport();
  return (
    <S.Container>
      <S.Row>
        <h2>
          <img src={BookIcon} alt="img" /> Cliente
        </h2>
        <S.Flex>
          <div>
            <p>Nome fantasia</p>
            <h3>{report?.occurrence?.client?.tradingName}</h3>
          </div>
          <div>
            <p>Razão Social</p>
            <h3>{report?.occurrence?.client?.name}</h3>
          </div>
          <div>
            <p>CNPJ</p>
            <h3>{report?.occurrence?.client?.cnpj}</h3>
          </div>
        </S.Flex>
        <S.Flex>
          <div className="with-margin">
            <p>E-mail</p>
            <h3>{report?.occurrence?.client?.email}</h3>
          </div>
          <div className="with-margin">
            <p>Nome do proprietário</p>
            <h3>{report?.occurrence?.client?.managerName}</h3>
          </div>
        </S.Flex>
      </S.Row>
      <S.Row>
        <h2>
          <img src={ProductIcon} alt="img" /> Produto
        </h2>
        <S.Flex>
          <div>
            <p>Nome do produto</p>
            <h3>{report?.occurrence?.client?.product?.name}</h3>
          </div>
          <div>
            <p>Regiões</p>
            {report?.occurrence?.client?.product?.regions.map((text, index) => (
              <li key={index}>
                {text[0]}, {text[1]}
              </li>
            ))}
          </div>
          <div>
            <p>Serviços</p>
            <h3>
              {report?.occurrence?.client?.product?.services
                ? report?.occurrence?.client?.product?.services[0].name
                : "-"}
            </h3>
          </div>
        </S.Flex>
      </S.Row>
      <S.Row>
        <h2>
          <img src={BeneficiaryIcon} alt="img" /> Beneficiário
        </h2>
        <S.Flex>
          <div>
            <p>Nome completo</p>
            <h3>
              {
                report?.occurrence?.occurrencesSuperficialAddresses
                  .superficialAddress?.superficialClient?.name
              }
            </h3>
          </div>
          <div>
            <p>CPF</p>
            <h3>
              {
                report?.occurrence?.occurrencesSuperficialAddresses
                  .superficialAddress?.superficialClient?.cpf
              }
            </h3>
          </div>
          <div>
            <p>RG</p>
            <h3>
              {
                report?.occurrence?.occurrencesSuperficialAddresses
                  .superficialAddress?.superficialClient?.rg
              }
            </h3>
          </div>
        </S.Flex>
        <S.Flex>
          <div className="with-margin">
            <p>E-mail</p>
            <h3>
              {
                report?.occurrence?.occurrencesSuperficialAddresses
                  .superficialAddress?.superficialClient?.email
              }
            </h3>
          </div>
          <div className="with-margin"></div>
        </S.Flex>
      </S.Row>
    </S.Container>
  );
}
